import FaydaVerification from "./pages/FaydaVerification";
import FaydaCallback from "./pages/FaydaCallback";
import { ProtectedRoute } from './components/ProtectedRoute';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Pending } from './pages/Pending';
import CustomerVerification from './pages/CustomerVerification';
import CustomerVerificationView from './pages/CustomerVerificationView';
import { Resolved } from './pages/Resolved';
import { Rejected } from './pages/Rejected';
import { UserManagement } from './pages/UserManagement';
import { AuthProvider } from './contexts/AuthContext'; // Add this import
import SessionManager from "./components/SessionManager";

function App() {
  return (
    <AuthProvider> {/* Wrap everything with AuthProvider */}
      <SessionManager>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/fayda-verification" element={<FaydaVerification />} />
            <Route path="/callback/verifayda" element={<FaydaCallback />} />
            <Route path="/login" element={<Login />} />

            {/* Protected routes */}
            <Route path="/" element={
             
                <Navigate to="/fayda-verification" replace />
             
            } />

            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />

            <Route path="/pending" element={
              <ProtectedRoute>
                <Pending />
              </ProtectedRoute>
            } />

            <Route path="/verify/:id" element={
              <ProtectedRoute>
                <CustomerVerification />
              </ProtectedRoute>
            } />

            <Route path="/approved/:id" element={
              <ProtectedRoute>
                <CustomerVerificationView />
              </ProtectedRoute>
            } />

            <Route path="/rejected/:id" element={
              <ProtectedRoute>
                <CustomerVerificationView />
              </ProtectedRoute>
            } />

            <Route
              path="/resolved"
              element={
                <ProtectedRoute>
                  <Resolved type="resolved" />
                </ProtectedRoute>
              }
            />

            <Route
              path="/approved-overridden"
              element={
                <ProtectedRoute>
                  <Resolved type="approved-overridden" />
                </ProtectedRoute>
              }
            />

            <Route path="/rejected" element={
              <ProtectedRoute>
                <Rejected />
              </ProtectedRoute>
            } />

            <Route path="/users" element={
              <ProtectedRoute requireAdmin>
                <UserManagement />
              </ProtectedRoute>
            } />

            {/* Catch-all route */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </SessionManager>
    </AuthProvider>
  );
}

export default App;